import { ImageModalComponent } from './image-modal.component';
import { ComponentModalConfig, ModalSize} from "ng2-semantic-ui";
import { IImageModalContext } from '../../core/models/imageModalcontext.interface';

export class ImageModal extends ComponentModalConfig<IImageModalContext, void, void> {
    constructor(title: string, source: string) {
        super(ImageModalComponent, { title, source });
        this.isClosable = false;
        this.transitionDuration = 200;
        this.size = ModalSize.Large;
    }
}